export default Object.freeze({
    TERMINACION_LABORAL: 10,
    SUJETO_A_PRUEBA: 20,
    TIEMPO_INDETERMINADO: 30
})
